import {
  OverlayArrow,
  TooltipTrigger,
  Tooltip as TooltipAria,
  type TooltipProps as TooltipPropsAria,
} from "react-aria-components";

import { DEFAULT_TOOLTIP_DELAY } from "@/lib/constants/delay";
import { cn } from "@/lib/helpers/cn";
import { tv } from "tailwind-variants";

import { Button2, type ButtonProps } from "../atoms/Button";

import "./Tooltip.styles.css";

type TooltipProps = TooltipPropsAria & {
  maxWidth?: string;
  text: string;
  triggerProps?: ButtonProps;
};

export function Tooltip2(props: TooltipProps) {
  const { children, maxWidth = "25ch", triggerProps, text, ...tooltipProps } = props;
  const { tooltip } = tooltipStyles();

  return (
    <TooltipTrigger delay={DEFAULT_TOOLTIP_DELAY}>
      <Button2
        // Bootstrap override. Assume if trigger props are passed tooltip is clickable
        className={cn(!triggerProps && "tw:!cursor-help")}
        variant="blank"
        {...triggerProps}
      >
        {children}
      </Button2>

      <TooltipAria {...tooltipProps} className={tooltip()} placement="bottom" style={{ maxWidth }}>
        <OverlayArrow className="react-aria-OverlayArrow">
          <svg fill="currentColor" width={12} height={6} viewBox="0 0 12 6">
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>

        {text}
      </TooltipAria>
    </TooltipTrigger>
  );
}

const tooltipStyles = tv({
  slots: {
    tooltip: cn(
      "react-aria-Tooltip", // aria builtin
      "tw:rounded-sm tw:p-2.5 tw:pb-2 tw:bg-fill-navy-primary",
      "tw:text-sm tw:text-text-white tw:outline-none",
    ),
  },
});
